<template>
    <div v-bind:class="{'code-input-container': true, [className]: !!className}">
        <div class="code-input">
            <div :style="`max-width:${fieldWidth}px; max-height:${fieldHeight}px; margin:0 0.${$vuetify.breakpoint.xsOnly ? '1' : '2'}em;`">
                <v-text-field outlined v-model="code"
                    :class="{'input-error' : isError}"
                    style="height:100%; width:100%; padding:1em 0.5em;"
                    @input="onValueChange" 
                    :disabled="disabled" :required="required" maxlength="6" />
            </div>
        </div>
        <v-fade-transition>
            <div v-if="isError"
                :style="`position:absolute; top:${fieldHeight + fieldHeight*0.05}px; width:100%;`">
                <div class="pa-3 pt-5 subtitle grey--text text--darken-2 d-flex flex-column align-center justify-center"
                    style="text-align:center; line-height:1em;">
                    <span>
                        {{ error }}
                    </span>
                </div>
            </div>
        </v-fade-transition>
    </div>
</template>

<script>
// Fork of: https://www.npmjs.com/package/vue-verification-code-input
export default {
    name: 'TwoFactorCodeInput',
    props: {
        type: {
            type: String,
            default: 'number'
        },
        className: {
            type: String
        },
        fieldCount: {
            type: Number,
            default: 6
        },
        fieldWidth: {
            type: Number,
            default: 150
        },
        fieldHeight: {
            type: Number,
            default: 54
        },
        disabled: {
            type: Boolean,
            default: false
        },
        required: {
            type: Boolean,
            default: false
        },
        change: {
            type: Function
        },
        complete: {
            type: Function
        },
        loading: {
            type: Boolean,
            default: false
        },
        error: {
            type: String
        }
    },
    data() {
        return {
            isError: false,
            code: ''
        }
    },
    methods: {
        onValueChange(e) {
            e = e.replace(/[^\d]/gi, '')
            
            // Emit the change event
            this.$emit('change', e)

            // If the value length is greater or equal than the amount of fileds, emit the complete event
            if (e.length >= this.fieldCount) {
                this.$emit('complete', e)
            }       
        },
        triggerChange(values) {
            // Get the number of fields
            const { fieldCount } = this

            // Get the current input
            const val = values.join('')

            // Emit the change event
            this.$emit('change', val)

            // If the value length is greater or equal than the amount of fileds, emit the complete event
            if (val.length >= fieldCount) {
                this.$emit('complete', val)
            }
        },
        resetValues() {
            this.code = ''
        }
    },
    watch: {
        error(err) {
            if (!!err) {
                this.isError = true
            }
        }
    }
}
</script>

<style scoped>
.code-input-container {
    position: relative;
}
.code-input {
    display: flex;
    flex-direction: row;
}
.code-input > div > input {
    transition: border 0.1s ease-out;
    border: solid 1px #a8adb7;
    border-right: none;
    font-size: 20px;
    color: #525461;
    text-align: center;
    box-sizing: border-box;
    border-radius: 0;
    -webkit-appearance: initial;
}
.code-input > div > input:last-child {
    border-right: solid 1px #a8adb7;
    border-top-right-radius: 6px;
    border-bottom-right-radius: 6px;
}
.code-input > div > input:first-child {
    border-top-left-radius: 6px;
    border-bottom-left-radius: 6px;
}
.code-input > div > input:focus {
    outline: none;
    border: 1px solid var(--md-purple);
    caret-color: var(--md-purple);
}
.code-input > div > input:focus + input {
    border-left: none;
}
.blur {
    position: absolute;
    inset: 0;
    background-color: #fff;
    opacity: 0.5;
    filter: blur(0.5px);
    transition: opacity 0.3s;
}
.input-error {
    border-color: #c95e5e !important;
}
</style>